import { BRAND_TO_FLOOR_MAP, FLOOR_TO_BRAND_MAP } from "@/constants";

export type Floor = keyof typeof BRAND_TO_FLOOR_MAP;
export type FloorCode = keyof typeof FLOOR_TO_BRAND_MAP;

export const determineFloorFromPath = (pathname: string): Floor | null => {
  const pathSegments = pathname.replace(/^\//, "").split("/");

  for (const segment of pathSegments) {
    const lowerSegment = segment.toLowerCase();
    if (lowerSegment in BRAND_TO_FLOOR_MAP) {
      return lowerSegment as Floor;
    }
  }

  return null;
};

export const getFloorFromCookie = (
  cookieValue: string | undefined,
): Floor | null => {
  if (cookieValue && cookieValue in FLOOR_TO_BRAND_MAP) {
    return FLOOR_TO_BRAND_MAP[cookieValue as keyof typeof FLOOR_TO_BRAND_MAP];
  }

  return null;
};

export const determineFloor = (
  cookieValue: string | undefined,
  pathname: string,
): Floor | null => {
  const floorFromPath = determineFloorFromPath(pathname);
  if (floorFromPath) {
    return floorFromPath;
  }

  const floorFromCookie = getFloorFromCookie(cookieValue);
  if (floorFromCookie) {
    return floorFromCookie;
  }

  return null;
};

export const getFloorCode = (floor: Floor): string => {
  return BRAND_TO_FLOOR_MAP[floor];
};
